import List from 'assets/icons/md/md-list.svg'

List.displayName = 'List'
export default List
